var DateTime = (() => {
    var _this, CONFIG;

    CONFIG = {
        fallbackZimeZone: 'Europe/Berlin'
    };

    _this = {
        getCurrentDateString: function() {
            var date;
            date = new Date();
            date = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000));
            return date.toISOString().split('T').shift();
        },

        getCurrentTimeString: function(withSeconds, fullHour) {
            var date, timeString;
            date = new Date();
            date = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000));
            if (fullHour) {
                date.setMinutes(0);
                date.setSeconds(0);
            }
            timeString = date.toISOString().split('T').pop().split('.').shift();
            if (!withSeconds) {
                timeString = timeString.split(':');
                timeString.pop();
                timeString = timeString.join(':');
            }
            return timeString;
        },

        getCurrentTimeZone: function() {
            return (window.Intl && window.Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone : CONFIG.fallbackZimeZone;
        },

        getTimeZones: function() {
            var timeZones;
            timeZones = (window.Intl && window.Intl.supportedValuesOf) ? Intl.supportedValuesOf('timeZone') : [CONFIG.fallbackZimeZone];
            timeZones.sort();
            return timeZones;
        },

        parseDateTime: function(value) {
            var valueParts, date, time;

            valueParts = String(value).split('T');

            if (valueParts.length === 2) {
                date = parseDate(valueParts[0]);
                time = parseTime(valueParts[1]);
                if (date && time) {
                    return Object.assign(date, time);
                }
            }

            return null;
        },

        parseDate: function(value, isLocalized) {
            let valueParts;

            // TODO use different localization separators
            valueParts = String(value).split(isLocalized ? '.' : '-');

            if (valueParts.length !== 3) {
                return null;
            }

            if (isLocalized) {
                // TODO use different localizations
                valueParts = [
                    valueParts[2],
                    valueParts[1],
                    valueParts[0]
                ];

            }
            
            return {
                year: parseInt(valueParts[0], 10),
                month: parseInt(valueParts[1], 10),
                day: parseInt(valueParts[2], 10)
            };
        },

        parseTime: function(value) {
            let valueParts;

            valueParts = String(value).split(':');

            if (valueParts.length !== 2) {
                return null;
            }

            return {
                hour: parseInt(valueParts[0], 10),
                minute: parseInt(valueParts[1], 10)
            };
        },

        formatDate: function(isoDate) {
            let valueParts;

            valueParts = String(isoDate).split('-');

            if (valueParts.length !== 3) {
                return '';
            }

            // TODO use different localizations
            return `${valueParts[2]}.${valueParts[1]}.${valueParts[0]}`;
        }
    };

    return _this;
})();